export const CHECKOUT_ERROR_MESSAGES = {
	avsDown: 'We are experiencing an issue. Please double check your address(es).',
	avsBillingRejected: 'We could not identify your billing address. Please check your Street Address and Zip Code.',
	avsShippingRejected: 'We could not identify your shipping address. Please check your Street Address and Zip Code.',
	avsSavedRejected: 'We could not identify your saved address. Please check your Street Address and Zip Code.',
	general: 'There was an issue processing your information. Please try again.',
	generalAddress: 'There was an issue processing your address information. Please re-enter and try again.',
	noInventory: 'There is no longer inventory available for an item in your order. Please return to your cart to edit your order.',
	paymentDeclined: 'There was an issue processing your payment information. Please re-enter and try again.',
	pricesChangedSinglePage: 'The pricing has changed from the time you started. Please refresh the page, re-confirm pricing, and re-enter your payment information',
	scorecardRequired: 'Please add a valid ScoreCard or remove what you have entered.',
	shippingRestriction: 'Due to shipping restrictions, some products in your shopping cart cannot be shipped to the address you provided',
	noCheckoutKey: 'Looks like you\'ve skipped a few steps. Head back to the cart and try again.',
	expiredPaymentMethod: 'Please select a valid payment method.',
	giftingAlreadyExists: 'We\'re sorry, but we can only send one gift email per order.',
	orderTotalChangedTitle: 'Your order total has changed.',
	orderTotalChanged: 'Please re-enter gift cards.',
	avsRejectedDPVCode0And2: 'The address provided could not be verified. Please review.',
	avsRejectedDPVCode3: 'The apartment number or rural box number could not be verified. Please review.',
	avsRejectedDPVCode4: 'The apartment number or rural box number is missing. Please review.',
	avsRejectedSDDZip: 'The address provided could not be verified. Changes to ZIP Code can be completed on Cart.',
	deleteSavedAddress: 'There was an issue deleting your address. Please try again.'
};

export const FIELD_ERROR_MESSAGE = {
	contact_first_name: {
		required: 'Please enter your first name.',
		pattern: 'Please enter a valid first name.'
	},
	contact_last_name: {
		required: 'Please enter your last name.',
		pattern: 'Please enter a valid last name.'
	},
	contact_email: {
		required: 'Please enter your email address.',
		pattern: 'Please enter a valid email address.'
	},
	contact_phone: {
		required: 'Please enter your phone number',
		pattern: 'Please enter a 10 digit phone number'
	},
	billing_address: {
		required: 'Please enter your billing address',
		pattern: 'Please enter a valid billing address'
	},
	billing_first_name: {
		required: 'Please enter your first name.',
		pattern: 'Please enter a valid first name.'
	},
	billing_last_name: {
		required: 'Please enter your last name.',
		pattern: 'Please enter a valid last name.'
	},
	billing_address2: {
		required: 'Please enter your billing address',
		pattern: 'Please enter a valid billing address'
	},
	billing_zipcode: {
		required: 'Please enter your billing zipcode.',
		pattern: 'Please enter a valid billing zipcode.'
	},
	billing_city: {
		required: 'Please enter a city for your billing address.',
		pattern: 'Please enter a valid city for your billing address.'
	},
	billing_state: {
		required: 'Please select a state for your billing address.'
	},
	shipping_first_name: {
		required: 'Please enter recipient\'s first name.',
		pattern: 'Please enter valid recipient\'s first name.'
	},
	shipping_last_name: {
		required: 'Please enter recipient\'s last name.',
		pattern: 'Please enter valid recipient\'s last name.'
	},
	shipping_address: {
		required: 'Please enter your shipping address',
		pattern: 'Please enter a valid shipping address'
	},
	shipping_address2: {
		required: 'Please enter your shipping address',
		pattern: 'Please enter a valid shipping address'
	},
	shipping_zipcode: {
		required: 'Please enter your shipping zipcode.',
		pattern: 'Please enter a valid shipping zipcode.'
	},
	shipping_city: {
		required: 'Please enter a city for your shipping address.',
		pattern: 'Please enter a valid city for your shipping address.'
	},
	shipping_state: {
		required: 'Please select a state for your shipping address.'
	},
	primary_shipping_first_name: {
		required: 'Please enter your first name.',
		pattern: 'Please enter a valid first name.'
	},
	primary_shipping_last_name: {
		required: 'Please enter your last name.',
		pattern: 'Please enter a valid last name.'
	},
	primary_shipping_address: {
		required: 'Please enter your shipping address',
		pattern: 'Please enter a valid shipping address'
	},
	primary_shipping_address2: {
		required: 'Please enter your shipping address',
		pattern: 'Please enter a valid shipping address'
	},
	primary_shipping_zipcode: {
		required: 'Please enter your shipping zipcode.',
		pattern: 'Please enter a valid shipping zipcode.'
	},
	primary_shipping_city: {
		required: 'Please enter a city for your shipping address.',
		pattern: 'Please enter a valid city for your shipping address.'
	},
	primary_shipping_state: {
		required: 'Please select a state for your shipping address.'
	},
	credit_card_number: {
		required: 'Please enter a valid credit card number.',
		pattern: 'Please enter a valid credit card number.'
	},
	credit_card_expDate: {
		required: 'Please enter a valid expiration date.',
		pattern: 'Please enter a valid expiration date.'
	},
	credit_card_CVC: {
		required: 'Please enter a valid security code.',
		pattern: 'Please enter a valid security code.'
	},
	proxy_first_name: {
		required: 'Please enter the additional pickup person\'s first name.',
		pattern: 'Please a valid first name for the additional pickup person.'
	},
	proxy_last_name: {
		required: 'Please enter the additional person\'s last name.',
		pattern: 'Please enter a valid last name for the additional pickup person.'
	},
	proxy_email: {
		required: 'Please enter the additional pickup person\'s email address.',
		pattern: 'Please enter a valid email address for the additional pickup person.'
	},
	shipping_first_name_gift: {
		required: 'Please enter recipient\'s first name.',
		pattern: 'Please enter valid recipient\'s first name.'
	},
	shipping_last_name_gift: {
		required: 'Please enter recipient\'s last name.',
		pattern: 'Please enter valid recipient\'s last name.'
	},
	shipping_address_gift: {
		required: 'Please enter recipient\'s shipping address',
		pattern: 'Please enter a valid recipient\'s shipping address'
	},
	shipping_address2_gift: {
		required: 'Please enter recipient\'s shipping address',
		pattern: 'Please enter a valid recipient\'s shipping address'
	},
	shipping_zipcode_gift: {
		required: 'Please enter recipient\'s shipping zipcode.',
		pattern: 'Please enter a valid recipient\'s shipping zipcode.'
	},
	shipping_city_gift: {
		required: 'Please enter a city for recipient\'s shipping address.',
		pattern: 'Please enter a valid city for recipient\'s shipping address.'
	},
	shipping_state_gift: {
		required: 'Please select a state for recipient\'s shipping address.'
	}
};

export const GIFT_CARD_ERROR_MESSAGE = {
	missingGiftCardAndPin: 'Please enter a gift card code and pin.',
	missingGiftCard: 'Please enter a gift card code.',
	missingPin: 'Please enter the pin on your gift card.',
	giftCardLength: 'Please enter a 16 digit gift card code.',
	giftCardLengthMJ: 'Please enter a 16 or 21 digit gift card code.',
	pinLength: 'Please enter an 8 digit pin.',
	pinLengthMJ: 'Please enter a 4, 6 or 8 digit pin.',
	pinLengthMJOnly: 'Please enter a 4 or 6 digit pin.',
	invalidGiftCard: 'Please enter a valid gift card.',
	alreadyAppliedGiftCard: 'This gift card is applied to your order.',
	noBalanceGiftCard: 'There is no remaining balance on this gift card.'
};
